import {
  DataEntryVehicleStepSectionPropsWithStep,
  FormikStep,
  typedMemo,
} from "src/types";
import { FormRow, InputText } from "src/ui/widgets";
import { useDataEntryVehicleStepVehicle } from "./vehicle-step-vehicle-section.hook";
import { FocusEvent } from "react";

export const DataEntryVehicleStepVehicle = typedMemo(
  (props: DataEntryVehicleStepSectionPropsWithStep) => {
    const {
      step,
      formikFieldBaseName,
      formikVehicleValues,
      formikVehicleErrors,
      formikVehicleTouched,
      formik,
      validationSchema,
    } = props;

    const { t, onPlateBlur } = useDataEntryVehicleStepVehicle(props);

    const { handleChange, handleBlur } = formik;

    return (
      <>
        <FormRow
          firstField={
            <InputText
              disabled={step == FormikStep.VEHICLE_A}
              name={`${formikFieldBaseName}.vehicleInfo.plate`}
              handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                e.target.value = e.target.value.toUpperCase();
                handleChange(e);
              }}
              handleBlur={onPlateBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.vehicleInfo?.plate}
              value={formikVehicleValues.vehicleInfo.plate}
              error={formikVehicleErrors?.vehicleInfo?.plate}
              label={`${t("commons.number_plate")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              name={`${formikFieldBaseName}.vehicleInfo.type`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.vehicleInfo?.type}
              value={formikVehicleValues.vehicleInfo.type}
              error={formikVehicleErrors?.vehicleInfo?.type}
              label={`${t("commons.brand_type")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              name={`${formikFieldBaseName}.vehicleInfo.registrationStatus`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.vehicleInfo?.registrationStatus}
              value={formikVehicleValues.vehicleInfo.registrationStatus}
              error={formikVehicleErrors?.vehicleInfo?.registrationStatus}
              label={`${t("commons.registration_status")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
      </>
    );
  },
);
